<div class="ar-card">

  <!-- Header -->
  <div class="ar-header">
    <div class="ar-header-left">
      <svg class="ar-warn-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
              fill="#f59e0b" stroke="#f59e0b" stroke-width="1"/>
        <line x1="12" y1="9" x2="12" y2="13" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
        <circle cx="12" cy="17" r="1" fill="#fff"/>
      </svg>
      <span class="ar-title">ACTION REQUIRED</span>
      <span class="ar-badge">{{ visibleActions.length }}</span>
    </div>
    <div class="ar-header-right">
      <span class="ar-only-you">Only for you</span>
      <span class="ar-showing">Showing {{ visibleActions.length }} — scroll for more</span>
    </div>
  </div>

  <!-- Action List -->
  <div class="ar-list">
    <div class="ar-item-wrapper" *ngFor="let item of visibleActions">

      <!-- Row -->
      <div class="ar-item" [class.ar-item--expanded]="item.expanded" (click)="toggleExpand(item)">
        <span class="ar-dot"></span>
        <span class="ar-label" [title]="item.label">{{ item.label }}</span>
        <span class="ar-date">{{ item.date }}</span>

        <!-- Chevron -->
        <svg class="ar-chevron" [class.ar-chevron--open]="item.expanded"
             viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2">
          <polyline points="6 9 12 15 18 9"/>
        </svg>

        <!-- Dismiss -->
        <button class="ar-dismiss" (click)="dismiss(item, $event)" title="Dismiss">
          <svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2.5" stroke-linecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      <!-- Expanded detail panel -->
      <div class="ar-detail" *ngIf="item.expanded">
        <p class="ar-detail-text">{{ item.detail }}</p>
        <p class="ar-detail-action" *ngIf="item.actionText">{{ item.actionText }}</p>
        <a class="ar-detail-link" [attr.href]="item.linkUrl || null" target="_blank" rel="noopener noreferrer">
          {{ item.linkLabel }} &rarr;
        </a>
      </div>

    </div>

    <div class="ar-empty" *ngIf="visibleActions.length === 0">
      No Action Items to display
    </div>
  </div>

</div>
